export default {
  nav: {
    dashboard: "Панель", forms: "Форми", roadmaps: "Маршрути", documents: "Документи",
    timeline: "Терміни", checklists: "Списки", deadlines: "Дедлайни",
    pricing: "Ціни", guides: "Посібники", dmvGuide: "Водійські права",
    signIn: "Увійти", startFree: "Безкоштовний посібник", startFreeShort: "Почати",
    profile: "Профіль", logOut: "Вийти",
  },
  footer: {
    tagline: "Покрокова навігація з ШІ для імміграційних процесів у США.",
    product: "Продукт", tools: "Інструменти", legal: "Правова інформація",
    greenCard: "Грін-карта", timelineCalc: "Калькулятор термінів",
    dvLottery: "Лотерея DV",
    privacy: "Політика конфіденційності", terms: "Умови використання", contact: "Контакти",
    disclaimer: "ImmigrationGuide не є юридичною фірмою і не надає юридичних консультацій. Цей інструмент надає лише загальну інформаційну допомогу.",
  },
  landing: {
    badge: "ШІ-навігатор для імміграції в США",
    title: "Імміграція в США",
    titleHighlight: "з впевненістю",
    subtitle: "Покрокове керівництво з ШІ для форм USCIS, Social Security та водійських прав. Без юридичного жаргону. Без плутанини. Тільки зрозуміла допомога.",
    ctaStart: "Безкоштовний посібник", ctaBrowse: "Усі посібники",
    socialProof: "форм заповнено цього місяця",
    popularTitle: "Найпопулярніші імміграційні посібники", popularLabel: "Популярні посібники",
    howTitle: "Три прості кроки", howLabel: "Як це працює",
    howSteps: [
      { num: "01", title: "Оберіть процес", desc: "Оберіть з форм USCIS, заяв Social Security або посібників з водійських прав." },
      { num: "02", title: "Отримайте допомогу ШІ", desc: "Наш ШІ пояснює кожне поле простою мовою та допомагає заповнити правильно." },
      { num: "03", title: "Подавайте з впевненістю", desc: "Перевірте аналіз ШІ, виявіть помилки заздалегідь та дізнайтеся, які документи потрібні." },
    ],
    featLabel: "Можливості", featTitle: "Все необхідне для навігації в імміграції",
    features: [
      { title: "Покроковий помічник з ШІ", desc: "Інтерактивний посібник проведе вас через кожне поле форми з зрозумілими поясненнями." },
      { title: "Аналіз з ШІ", desc: "Отримайте персональні рекомендації, можливі проблеми та поради після заповнення форм." },
      { title: "Завантаження та перевірка документів", desc: "Завантажте документи, і ШІ перевірить їх на відсутні файли та невідповідності." },
      { title: "Хронологія процесу", desc: "Візуальний трекер, що показує, на якому етапі імміграційного процесу ви перебуваєте." },
      { title: "Персональні списки", desc: "Списки документів, створені ШІ на основі вашого типу візи та ситуації." },
      { title: "Відстеження термінів", desc: "Ніколи не пропустіть термін подачі завдяки розумному відстеженню та нагадуванням." },
    ],
    pricingLabel: "Ціни", pricingTitle: "Почніть безкоштовно, оновіть коли будете готові",
    free: "Безкоштовно", freePer: "/міс",
    freeFeatures: ["Доступ до всіх посібників", "Базовий помічник з ШІ", "Маршрути процесів", "Інформація спільноти"],
    pro: "Преміум", proPer: "/міс", proBadge: "Найпопулярніший",
    proFeatures: ["Аналіз та рекомендації ШІ", "Перевірка документів", "Відстеження хронології", "Персональні списки", "Відстеження термінів", "Пріоритетна підтримка"],
    valueStatement: "Відкрийте перевірку документів з ШІ, яка знаходить помилки до відправки.",
    compTitle: "Порівняння планів",
    proCtaStart: "Почати Преміум",
    ctaTitle: "Готові розпочати свій імміграційний шлях?",
    ctaSubtitle: "Приєднуйтесь до тисяч іммігрантів, які використовують ImmigrationGuide для навігації по державних формах США з впевненістю.",
    heroDisclaimer: "ImmigrationGuide не є юридичною фірмою і не надає юридичних консультацій.",
    qualitativeProof: "Покрокове керівництво для I-485, I-130, I-765, SS-5 та процесів DMV",
    dvLotteryName: "Лотерея DV",
    dvLotteryDesc: "Право на участь та посібник програми Diversity Visa",
    faqLabel: "Часті запитання",
    faqTitle: "Поширені запитання",
    faq1Q: "Чи безпечні мої дані?",
    faq1A: "Так. Усі дані шифруються при передачі (TLS) та зберіганні (AES-256). Ми ніколи не зберігаємо вашу інформацію у відкритому вигляді, і ви можете запросити повне видалення даних у будь-який час.",
    faq2Q: "Ви пов'язані з USCIS?",
    faq2A: "Ні. ImmigrationGuide — це незалежна освітня платформа. Ми не пов'язані з USCIS, Державним департаментом чи будь-яким державним органом. Ми ніколи не передаємо ваші дані державним органам.",
    faq3Q: "Що відбувається з завантаженими документами?",
    faq3A: "Документи зберігаються у зашифрованому вигляді та використовуються лише для перевірки форм за допомогою ШІ. Вони ніколи не передаються третім особам. Ви можете видалити всі завантажені файли у будь-який час на сторінці Документи.",
    pricingValue: "Відкрийте перевірку документів з ШІ, яка знаходить помилки до відправки.",
    compFeature: "Функція",
    compPrice: "Ціна",
    compFeatures: ["Покроковий помічник", "Персональний список", "Візуальна хронологія", "Перевірка форм з ШІ", "Завантаження та валідація документів", "Відстеження термінів та нагадування", "Керування кількома формами", "Пріоритетна підтримка"],
  },
  gc: {
    badge: "Повний посібник з Грін-карти", title: "Посібник з Грін-карти", titleHighlight: "для іммігрантів",
    subtitle: "Покрокова допомога з формами, документами, термінами та типовими помилками. Розберіться в кожному етапі отримання постійного виду на проживання в США.",
    ctaStart: "Безкоштовний посібник", ctaTimeline: "Терміни отримання Грін-карти",
    whatTitle: "Що таке Грін-карта?",
    whatP1: "Грін-карта (офіційно — Картка постійного резидента) дає вам дозвіл жити та працювати в США на постійній основі. Це найпоширеніший шлях до громадянства США.",
    whatP2: "Як власник Грін-карти, ви можете працювати на будь-якого роботодавця, вільно подорожувати, спонсорувати певних членів сім'ї та, виконавши вимоги до проживання, подати на громадянство США через натуралізацію.",
    pathsLabel: "Право на отримання", pathsTitle: "Основні шляхи отримання Грін-карти",
    paths: [
      { title: "На основі сім'ї", desc: "Спонсорство подружжям, батьком, дитиною або братом/сестрою — громадянином або резидентом США." },
      { title: "На основі роботи", desc: "Спонсорство американським роботодавцем через трудову сертифікацію або спеціальні категорії (EB-1 — EB-5)." },
      { title: "Зміна статусу", desc: "Подайте заяву на Грін-карту, перебуваючи на території США (Форма I-485)." },
      { title: "Консульська обробка", desc: "Подайте через посольство або консульство США у вашій країні після схвалення петиції." },
      { title: "Спеціальні категорії", desc: "Лотерея віз, статус біженця/притулку, VAWA та інші гуманітарні програми." },
    ],
    formsLabel: "Форми", formsTitle: "Найпоширеніші форми для Грін-карти",
    openGuide: "Відкрити посібник", startWizard: "Почати помічник", browseGuides: "Усі посібники",
    forms: [
      { code: "I-130", name: "Петиція про родича-іноземця", desc: "Подається громадянином або резидентом США для підтвердження родинних зв'язків з іноземним родичем." },
      { code: "I-485", name: "Зміна статусу", desc: "Заява на отримання статусу постійного резидента, перебуваючи на території США." },
      { code: "I-765", name: "Дозвіл на роботу", desc: "Заява на отримання дозволу на роботу (EAD), щоб легально працювати поки Грін-карта розглядається." },
      { code: "I-864", name: "Афідавіт про підтримку", desc: "Ваш спонсор підтверджує достатній дохід для вашого фінансового забезпечення в США." },
      { code: "I-693", name: "Медичний огляд", desc: "Пройдіть медогляд у лікаря, призначеного USCIS, для підтвердження відповідності вимогам здоров'я." },
    ],
    processLabel: "Процес", processTitle: "Покроковий процес отримання Грін-карти",
    processSteps: [
      { title: "Визначити право на отримання", desc: "Визначте, яка категорія Грін-карти застосовна до вашого випадку." },
      { title: "Подати імміграційну петицію", desc: "Ваш спонсор подає Форму I-130 (сім'я) або I-140 (робота) до USCIS." },
      { title: "Очікування пріоритетної дати", desc: "Якщо у вашій категорії є черга, зачекайте, поки ваша дата стане актуальною." },
      { title: "Подати I-485 або консульська обробка", desc: "Подайте заяву на зміну статусу (I-485) або пройдіть консульську обробку за кордоном." },
      { title: "Біометрична перевірка", desc: "Відвідайте центр підтримки USCIS для зняття відбитків пальців та фото." },
      { title: "Проходження інтерв'ю", desc: "Зустрітьтеся з офіцером USCIS або консульства для розгляду вашої заяви." },
      { title: "Отримання рішення", desc: "USCIS схвалює, відхиляє або запитує додаткові докази." },
      { title: "Отримання Грін-карти", desc: "У разі схвалення ваша картка постійного резидента буде надіслана поштою на вашу адресу в США." },
    ],
    startGuidedWizard: "Почати покроковий помічник",
    docsLabel: "Документи", docsTitle: "Список необхідних документів",
    docs: [
      "Дійсний паспорт (усі заявники)", "Свідоцтво про народження із завіреним перекладом англійською",
      "Свідоцтво про шлюб (якщо застосовно)", "Свідоцтва про розлучення або смерть від попередніх шлюбів",
      "Повідомлення про схвалення Форми I-130", "Форма I-864 Афідавіт + податкові декларації",
      "Дві фотографії паспортного зразка", "Запечатаний медичний висновок I-693",
      "Довідки про несудимість", "Лист від роботодавця або докази фінансової підтримки",
      "Докази справжніх стосунків (фото, листування, договори оренди)", "Копія документів поточного імміграційного статусу (віза, I-94)",
    ],
    checklistCtaTitle: "Потрібен персональний список?",
    checklistCtaDesc: "Наш ШІ створить персональний список документів на основі вашого типу візи, сімейного стану та країни.",
    generateChecklist: "Створити мій список",
    mistakesLabel: "Уникайте цього", mistakesTitle: "Типові помилки при подачі на Грін-карту",
    mistakes: [
      "Подача непідписаних або неповних форм", "Використання застарілих версій форм (завжди завантажуйте з uscis.gov)",
      "Забули додати правильну плату", "Невідповідні дати в різних формах",
      "Не переклали документи іноземною мовою на англійську", "Пропуск біометричної перевірки без перенесення",
      "Не розкрили попередні імміграційні порушення", "Відправка заяви на неправильну адресу USCIS",
      "Недостатньо доказів справжності стосунків", "Закінчення терміну дозволу на роботу під час очікування",
    ],
    checkDocs: "Перевірити мої документи з ШІ",
    timelineLabel: "Терміни", timelineTitle: "Терміни отримання Грін-карти",
    timelineDesc: "Оцініть, скільки часу може зайняти ваш процес отримання Грін-карти.",
    timelineCta: "Калькулятор термінів Грін-карти",
    immediateRelatives: "Найближчі родичі", familyPreference: "Сімейна категорія", employmentBased: "На основі роботи",
    faqLabel: "Запитання", faqTitle: "Часті запитання про Грін-карту",
    faqs: [
      { q: "Скільки часу займає отримання Грін-карти?", a: "Терміни суттєво відрізняються. Найближчі родичі громадян США зазвичай чекають 12-18 місяців. Сімейні та робочі категорії можуть зайняти 2-10+ років." },
      { q: "У чому різниця між I-130 та I-485?", a: "Форма I-130 — імміграційна петиція, що підтверджує родинні зв'язки. Форма I-485 — заява на зміну статусу. Для сімейної Грін-карти потрібні обидві форми." },
      { q: "Чи можу я працювати, поки заява розглядається?", a: "Так. Подайте Форму I-765 разом з I-485. Після схвалення ви отримаєте EAD для легальної роботи." },
      { q: "Скільки коштує подача на Грін-карту?", a: "Плата за I-485: $1,225. Петиція I-130: $535. Загальна вартість зазвичай $2,000-$5,000+." },
      { q: "Що відбувається на інтерв'ю?", a: "Офіцер USCIS розглядає заяву, задає питання, перевіряє документи та приймає рішення. Інтерв'ю зазвичай 15-30 хвилин." },
      { q: "Чи можу я подорожувати, поки Грін-карта розглядається?", a: "Не виїжджайте з США без документа Advance Parole (Форма I-131). Виїзд без нього може вважатися відмовою від заяви I-485." },
      { q: "Що таке пріоритетна дата?", a: "Дата подачі вашої імміграційної петиції. Потрібно чекати, поки дата стане 'актуальною' за візовим бюлетенем." },
      { q: "Що робити, якщо заяву відхилено?", a: "Можна подати клопотання про перегляд, оскаржити в BIA або подати повторно. Рекомендуємо звернутися до імміграційного адвоката." },
    ],
    finalTitle: "Готові розпочати процес отримання Грін-карти?",
    finalSubtitle: "ImmigrationGuide проведе вас через кожну форму, документ і крок. Почніть безкоштовно.",
  },
  gct: {
    badge: "Калькулятор термінів", title: "Грін-карта", titleHighlight: "Калькулятор термінів",
    subtitle: "Оцініть, скільки часу може зайняти ваш процес отримання Грін-карти.",
    ctaStart: "Розрахувати терміни", ctaGuide: "Посібник з Грін-карти",
    howTitle: "Як працюють терміни Грін-карти",
    howP1: "Терміни обробки Грін-карт суттєво відрізняються і залежать від кількох факторів:",
    howFactors: ["Імміграційна категорія (сім'я чи робота)", "Країна народження", "Доступність віз (річні ліміти)", "Швидкість обробки USCIS", "Ваша пріоритетна дата"],
    calcLabel: "Калькулятор", calcTitle: "Розрахуйте терміни вашої Грін-карти",
    calcCategory: "Категорія Грін-карти", calcCategoryPh: "Оберіть категорію...",
    calcCountry: "Країна народження", calcCountryPh: "Оберіть країну народження...",
    calcProcessing: "Тип обробки", calcProcessingPh: "Оберіть тип обробки...",
    calcFamilyLabel: "На основі сім'ї", calcEmploymentLabel: "На основі роботи",
    calcButton: "Розрахувати терміни",
    resultLabel: "Орієнтовні терміни", resultStepsTitle: "Орієнтовні етапи процесу",
    resultSteps: ["Подача петиції", "Схвалення петиції", "Доступність візи", "Зміна статусу / Консульська обробка", "Інтерв'ю", "Схвалення Грін-карти"],
    resultFromStart: "з початку",
    resultDisclaimer: "Це оцінки на основі історичних даних USCIS. Фактичні терміни можуть відрізнятися.",
    resultTrack: "Відстежувати прогрес", resultRecalc: "Перерахувати",
    rangesLabel: "Терміни обробки", rangesTitle: "Типові терміни обробки Грін-карти",
    delaysLabel: "Затримки", delaysTitle: "Частіі причини затримок",
    delays: [
      { title: "Відсутні або неповні документи", desc: "USCIS видає запит на докази (RFE), що може додати 2-4 місяці." },
      { title: "Затримка візового бюлетеня", desc: "Ваша пріоритетна дата повинна стати актуальною для розгляду справи." },
      { title: "Запит на докази (RFE)", desc: "Якщо USCIS потребує додаткової інформації, справу призупиняють. Зазвичай дають 87 днів." },
      { title: "Перевірка біографії", desc: "Перевірки безпеки можуть спричинити непередбачувані затримки." },
      { title: "Затримки призначення інтерв'ю", desc: "Деякі офіси USCIS мають довгі черги." },
      { title: "COVID або зміни політики", desc: "Державні закриття або надзвичайні ситуації можуть тимчасово зупинити обробку." },
    ],
    checkDocs: "Перевірити мої документи",
    guideLinkTitle: "Розберіться в повному процесі Грін-карти", guideLinkDesc: "Наш посібник пояснює кожну форму, документ і крок.",
    guideLinkCta: "Відкрити посібник з Грін-карти",
    faqLabel: "Запитання", faqTitle: "Запитання про терміни Грін-карти",
    faqs: [
      { q: "Скільки часу займає Грін-карта?", a: "Залежить від категорії та країни. Найближчі родичі — 12-18 міс. Сімейні категорії — 2-25+ років." },
      { q: "Що впливає на терміни обробки?", a: "Категорія, країна народження, доступність віз та швидкість обробки USCIS." },
      { q: "Що таке пріоритетна дата?", a: "Дата подачі вашої петиції. Справа не може просуватися, поки дата не стане 'актуальною'." },
      { q: "Чому важлива країна народження?", a: "Закон обмежує кількість Грін-карт на країну (~7% від загальної кількості). Країни з високим попитом мають багаторічні черги." },
      { q: "Скільки чекати інтерв'ю після біометрії?", a: "Зазвичай 2-8 місяців, залежно від вашого місцевого офісу USCIS." },
    ],
    visaBulletinBadge: "Незабаром", visaBulletinTitle: "Передбачувач візового бюлетеня",
    visaBulletinDesc: "Прогноз пріоритетної дати, оцінка очікування та прогноз затримок за країнами.",
    visaBulletinCta: "Отримати сповіщення",
    finalTitle: "Почніть процес Грін-карти з ImmigrationGuide",
    finalSubtitle: "Покрокова допомога ШІ для кожної форми, документа і терміну. Почніть безкоштовно.",
    finalStart: "Безкоштовний посібник", finalChecklist: "Створити мій список",
  },
  guides: {
    badge: "Імміграційні посібники", title: "Повні посібники з імміграції в США",
    subtitle: "Покрокові посібники з кожної форми. Безкоштовні пояснення, необхідні документи, типові помилки та допомога ШІ.",
    immigration: "Імміграція", govServices: "Державні послуги", dmv: "Водійські права",
    greenCard: "Грін-карта",
    greenCardDesc: "Заява на реєстрацію постійного проживання",
    familyPetition: "Сімейна петиція",
    familyPetitionDesc: "Петиція для родича-іноземця",
    workAuth: "Дозвіл на роботу",
    workAuthDesc: "Заява на дозвіл на працевлаштування",
    ssCard: "Соціальне забезпечення",
    ssCardDesc: "Заява на картку соціального забезпечення",
    dmvGuide: "Водійські права",
    dmvGuideDesc: "Вимоги по штатах для іммігрантів",
  },
  privacy: {
    title: "Політика конфіденційності", updated: "Останнє оновлення: Лютий 2026",
    sections: [
      { title: "1. Яку інформацію ми збираємо", body: "При створенні облікового запису ми збираємо ваше ім'я, електронну пошту та пароль (зберігається у захищеному хеші). При вході через Google отримуємо ім'я, email та фото профілю.\n\nПри використанні інструментів зберігаємо відповіді в помічнику, метадані документів, терміни та налаштування списків." },
      { title: "2. Завантажені документи", body: "Файли зберігаються на захищених серверах. ШІ аналізує метадані для перевірки повноти. Ми не продаємо і не передаємо ваші документи." },
      { title: "3. Як ми використовуємо інформацію", body: "Ми використовуємо інформацію для надання сервісу: персональних списків, помічника з ШІ, відстеження хронології та нагадувань." },
      { title: "4. Аутентифікація", body: "Два способи входу: email/пароль (bcrypt + JWT) та Google OAuth. Ми не зберігаємо ваш пароль Google." },
      { title: "5. Аналітика та файли cookie", body: "Базова аналітика продукту. Сесійні cookie для підтримки входу. Без рекламних трекерів." },
      { title: "6. Передача даних", body: "Не продаємо дані. Передаємо лише провайдеру ШІ (OpenAI) та хостинг-провайдерам за необхідності." },
      { title: "7. Ваші права", body: "Ви можете запросити доступ, виправлення або видалення даних. Можете видалити обліковий запис будь-коли." },
      { title: "8. Контакти", body: "З питань конфіденційності: support@immigrationguide.us." },
    ],
  },
  terms: {
    title: "Умови використання", updated: "Останнє оновлення: Лютий 2026",
    sections: [
      { title: "1. Опис сервісу", body: "ImmigrationGuide — онлайн-платформа з ШІ для інформаційної допомоги з імміграційних форм та державних процесів США." },
      { title: "2. Не є юридичною консультацією", body: "ImmigrationGuide не є юридичною фірмою. Інформація надається виключно для освітніх цілей. Завжди перевіряйте на uscis.gov та консультуйтесь з імміграційним адвокатом." },
      { title: "3. Обов'язки користувача", body: "Ви відповідаєте за точність інформації та її перевірку перед подачею до державних органів." },
      { title: "4. Облікові записи", body: "Надавайте точну інформацію при створенні. Ви відповідаєте за всю активність в обліковому записі." },
      { title: "5. Підписка та оплата", body: "Безкоштовний та преміум-плани. Підписки продовжуються автоматично. Скасувати можна будь-коли." },
      { title: "6. Контент, створений ШІ", body: "Інструменти ШІ генерують рекомендації на основі загальних знань. Контент може містити помилки. Не покладайтеся виключно на нього." },
      { title: "7. Обмеження відповідальності", body: "У максимальному обсязі, дозволеному законом, ми не несемо відповідальності за непрямі збитки. Загальна відповідальність не перевищує суму, сплачену за останні 12 місяців." },
      { title: "8. Інтелектуальна власність", body: "Весь контент і технологія належать нам. Ви зберігаєте право власності на свої дані та документи." },
      { title: "9. Зміни умов", body: "Ми можемо оновлювати умови. Зареєстровані користувачі будуть повідомлені про суттєві зміни." },
      { title: "10. Контакти", body: "З питань щодо умов: support@immigrationguide.us." },
    ],
  },
  contact: {
    title: "Зв'яжіться з нами", subtitle: "Маєте запитання або потребуєте допомоги? Напишіть нам, і ми відповімо якнайшвидше.",
    email: "Електронна пошта", responseTime: "Час відповіді", responseValue: "Протягом 24 годин",
    name: "Ім'я", namePh: "Ваше ім'я", emailLabel: "Електронна пошта", emailPh: "ви@приклад.com",
    message: "Повідомлення", messagePh: "Чим ми можемо допомогти?",
    send: "Надіслати", successTitle: "Повідомлення надіслано",
    successDesc: "Дякуємо за звернення. Ми відповімо протягом 24 годин.",
    sendAnother: "Надіслати ще",
  },
  dvl: {
    badge: "Гід програми DV",
    title: "Лотерея Грін-карт",
    titleHighlight: "(Програма DV) Гід",
    subtitle: "Дізнайтеся, як працює лотерея DV, хто може брати участь, ключові дати та як підготувати заявку.",
    ctaEligibility: "Перевірити право на участь",
    ctaStart: "Безкоштовний гід з імміграції",
    whatTitle: "Що таке лотерея Грін-карт?",
    whatP1: "Лотерея DV (Diversity Visa) — також відома як лотерея Грін-карт — це програма уряду США, що надає до 55 000 імміграційних віз щороку громадянам країн з історично низьким рівнем імміграції до США.",
    whatP2: "Заявники відбираються випадковим чином через комп'ютерний розіграш. Переможці та їхні сім'ї можуть подати заявку на постійне проживання (грін-карту).",
    whatHighlights: [
      { num: "55 000", label: "Грін-карт видається на рік" },
      { num: "Випадковий", label: "Комп'ютерний відбір" },
      { num: "Безкоштовно", label: "Без плати за реєстрацію" },
    ],
    datesLabel: "Ключові дати",
    datesTitle: "Ключові дати лотереї DV",
    dates: [
      { period: "Жовтень – Листопад", title: "Період реєстрації", desc: "Вікно онлайн-реєстрації на dvprogram.state.gov зазвичай відкривається на початку жовтня і закривається на початку листопада." },
      { period: "Травень", title: "Оголошення результатів", desc: "Учасники можуть перевірити статус відбору онлайн з травня, використовуючи номер підтвердження." },
      { period: "Жовтень – Вересень", title: "Обробка візи", desc: "Відібрані заявники проходять обробку візи протягом фіскального року: подання форм, співбесіда, медогляд." },
    ],
    ctaTimeline: "Переглянути хронологію Грін-карти",
    eligLabel: "Право участі",
    eligTitle: "Хто може брати участь у лотереї DV?",
    eligIntro: "Для участі в лотереї DV заявники повинні відповідати таким вимогам:",
    eligReqs: [
      { title: "Країна народження", desc: "Ви повинні народитися в відповідній країні. Країни з понад 50 000 іммігрантів за останні 5 років виключені." },
      { title: "Вимога до освіти", desc: "Необхідна середня освіта або еквівалент (12 років), АБО два роки кваліфікованого досвіду роботи." },
      { title: "Альтернатива — досвід роботи", desc: "Якщо ви не відповідаєте вимогам до освіти, можете кваліфікуватися з двома роками досвіду роботи." },
      { title: "Вимоги до фотографії", desc: "Необхідно надати фото: 600×600 пікселів, білий фон, без окулярів, зроблене за останні 6 місяців." },
    ],
    howLabel: "Процес подачі",
    howTitle: "Як подати заявку на лотерею Грін-карт",
    howSteps: [
      { title: "Зареєструйтеся на офіційному сайті", desc: "Перейдіть на dvprogram.state.gov у період реєстрації. Це єдиний легітимний сайт." },
      { title: "Надішліть особисту інформацію", desc: "Вкажіть ім'я, дату народження, країну, рівень освіти та контактні дані." },
      { title: "Завантажте фотографію", desc: "Завантажте фото відповідно до вимог: 600×600 пікселів, білий фон, без окулярів." },
      { title: "Збережіть номер підтвердження", desc: "Після відправки ви отримаєте номер підтвердження. Збережіть його — це єдиний спосіб перевірити результати." },
      { title: "Перевірте результати у травні", desc: "Поверніться на офіційний сайт у травні. НЕ довіряйте листам або дзвінкам про виграш — це шахрайство." },
    ],
    ctaChecklist: "Створити чек-лист заявки",
    mistakesLabel: "Часті помилки",
    mistakesTitle: "Часті помилки в лотереї DV",
    mistakes: [
      { title: "Невірний формат фото", desc: "Фотографії, що не відповідають специфікаціям — причина №1 дискваліфікації." },
      { title: "Втрата номера підтвердження", desc: "Без номера підтвердження неможливо перевірити статус. Відновити його не можна." },
      { title: "Дублювання заявок", desc: "Подача більше однієї заявки на особу призведе до дискваліфікації всіх заявок." },
      { title: "Невірні особисті дані", desc: "Будь-яка розбіжність між заявкою та паспортом може призвести до відмови у візі." },
    ],
    ctaCheckDocs: "Перевірити мої документи",
    checklistLabel: "Підготовка",
    checklistTitle: "Чек-лист для лотереї DV",
    checklistIntro: "Переконайтеся, що у вас все готово до відкриття реєстрації:",
    checklistItems: [
      "Дійсний паспорт з коректними біографічними даними",
      "Цифрове фото за специфікаціями Держдепартаменту (600×600 px)",
      "Атестат про середню освіту або еквівалент",
      "Документація про досвід роботи (якщо застосовно)",
      "Інформація та фото подружжя/дітей (якщо застосовно)",
      "Безпечне місце для зберігання номера підтвердження",
      "Доступ до комп'ютера та інтернету в період реєстрації",
      "Закладка офіційного сайту: dvprogram.state.gov",
    ],
    ctaGenChecklist: "Створити мій чек-лист",
    compLabel: "Порівняння",
    compTitle: "Лотерея DV vs інші шляхи до Грін-карти",
    compIntro: "Як лотерея DV порівнюється з іншими способами отримання грін-карти?",
    compHeaders: ["Критерій", "Лотерея DV", "Сімейна", "Робоча"],
    compRows: [
      ["Вартість", "Безкоштовно", "$535+", "$700+"],
      ["Термін", "1–2 роки", "1–20+ років", "1–10+ років"],
      ["Відбір", "Випадкова лотерея", "За петицією", "Спонсор-роботодавець"],
      ["Річний ліміт", "55 000 віз", "226 000 віз", "140 000 віз"],
      ["Вимога", "Освіта/Робота", "Сімейні зв'язки", "Пропозиція роботи"],
      ["Складність", "Удача", "Залежить від родства", "Залежить від роботодавця"],
    ],
    ctaGuide: "Відкрити гід по Грін-карті",
    faqLabel: "Часті запитання",
    faqTitle: "FAQ лотереї Грін-карт",
    faqs: [
      { q: "Що таке лотерея DV?", a: "Це програма уряду США, яка щороку випадковим чином відбирає до 55 000 осіб з країн з низьким рівнем імміграції." },
      { q: "Хто може брати участь?", a: "Громадяни відповідних країн з атестатом про середню освіту або двома роками кваліфікованого досвіду роботи." },
      { q: "Коли відкривається реєстрація?", a: "Зазвичай у жовтні, закривається в листопаді. Перевіряйте dvprogram.state.gov." },
      { q: "Скільки людей виграє?", a: "Близько 55 000 віз, але відбирається понад 100 000 для компенсації незавершених заявок." },
      { q: "Що відбувається після виграшу?", a: "Потрібно подати форму DS-260, зібрати документи, пройти співбесіду та медогляд." },
      { q: "Чи можуть члени сім'ї брати участь разом?", a: "Кожен може подати свою заявку. Якщо один виграє, подружжя та діти до 21 року також отримають грін-карти." },
      { q: "Яке фото потрібне?", a: "Цифрове фото за останні 6 місяців, 600×600 пікселів, білий фон, без окулярів." },
      { q: "Що якщо я втрачу номер підтвердження?", a: "Відновити його неможливо. Збережіть його в кількох безпечних місцях одразу після реєстрації." },
      { q: "Лотерея DV дійсно випадкова?", a: "Так. Відбір проводиться випадковим комп'ютерним розіграшем. Кожна заявка має рівні шанси." },
      { q: "Участь безкоштовна?", a: "Так, повністю безкоштовно. Якщо хтось просить оплату — це шахрайство." },
    ],
    finalTitle: "Почніть свій імміграційний шлях сьогодні",
    finalSubtitle: "Чи то лотерея DV, чи інші шляхи — ImmigrationGuide допоможе вам на кожному кроці.",
    ctaFinalStart: "Безкоштовний гід",
    ctaFinalEligibility: "Перевірити право",
  },
  dvf: {
    badge: "Гід по заповненню форми DV",
    title: "Як правильно заповнити форму лотереї DV",
    titleHighlight: "Правильно",
    subtitle: "Покрокові інструкції, правила фото та поширені помилки при подачі заявки на лотерею Грін-карт.",
    ctaEligibility: "Перевірити право на участь",
    ctaChecklist: "Створити чек-лист заявки",
    beforeLabel: "Підготовка",
    beforeTitle: "Перед початком: що підготувати",
    beforeIntro: "Зберіть наступну інформацію та документи перед заповненням заявки.",
    beforeItems: [
      { title: "Особисті дані", desc: "Повне ім'я (як у паспорті), дата народження та місто/країна народження." },
      { title: "Дані про сім'ю", desc: "Імена, дати та міста народження подружжя та всіх неодружених дітей до 21 року." },
      { title: "Дані про освіту", desc: "Найвищий рівень завершеної освіти." },
      { title: "Країна народження та право", desc: "Ваша країна народження та, якщо відрізняється, країна для заявки на право." },
      { title: "Цифрове фото", desc: "Фото за вимогами: 600×600 пікселів, білий фон, за останні 6 місяців." },
      { title: "Зберігання номера підтвердження", desc: "Підготуйте безпечне місце для зберігання номера підтвердження одразу після відправки." },
    ],
    fieldsLabel: "Інструкції по полях",
    fieldsTitle: "Покрокова інструкція по заповненню форми DV",
    fieldsIntro: "Офіційна форма на dvprogram.state.gov містить наступні поля:",
    fields: [
      { title: "Повне ім'я", desc: "Введіть ім'я як у паспорті. Спочатку прізвище, потім ім'я, потім по батькові." },
      { title: "Стать", desc: "Оберіть чоловічу або жіночу, як у паспорті." },
      { title: "Дата народження", desc: "Введіть дату народження. Перевірте збіг з паспортом." },
      { title: "Місто і країна народження", desc: "Введіть місто і країну народження. Використовуйте сучасну назву країни." },
      { title: "Країна права", desc: "Зазвичай це країна народження. Якщо вона не підходить, можна заявити через країну народження подружжя." },
      { title: "Завантаження фото", desc: "Завантажте фото: 600×600 пікселів, білий фон, без окулярів, нещодавнє." },
      { title: "Поштова адреса", desc: "Введіть повну адресу: вулиця, місто, штат/область, індекс і країна." },
      { title: "Країна проживання", desc: "Оберіть країну, де зараз живете." },
      { title: "Телефон", desc: "Введіть номер з кодом країни. Необов'язково, але рекомендується." },
      { title: "Електронна пошта", desc: "Введіть дійсну адресу. Держдеп НЕ надсилає результати поштою." },
      { title: "Рівень освіти", desc: "Оберіть найвищий рівень. Мінімум — атестат про середню освіту." },
      { title: "Сімейний стан", desc: "Оберіть поточний стан. Якщо одружені, вкажіть дані подружжя." },
      { title: "Дані подружжя", desc: "Вкажіть повне ім'я, дату народження, стать, місто/країну народження та завантажте фото." },
      { title: "Дані про дітей", desc: "Вкажіть всіх неодружених дітей до 21 року, включаючи пасинків та прийомних." },
    ],
    photoLabel: "Вимоги до фото",
    photoTitle: "Правила фото для лотереї DV",
    photoIntro: "Фото — одна з найкритичніших частин заявки. Неправильні фото — головна причина дискваліфікації.",
    photoRules: [
      { title: "Свіже фото", desc: "За останні 6 місяців. Старі фото будуть відхилені." },
      { title: "Правильні розміри", desc: "Рівно 600×600 пікселів, квадратне, формат JPEG." },
      { title: "Однотонний фон", desc: "Тільки білий або майже білий фон." },
      { title: "Без обробки", desc: "Без фільтрів та ретуші. Без окулярів, капелюхів та головних уборів." },
    ],
    ctaPhotoCheck: "Перевірити вимоги до фото",
    mistakesLabel: "Поширені помилки",
    mistakesTitle: "Поширені помилки у формі DV",
    mistakesIntro: "Уникайте цих помилок:",
    mistakes: [
      { title: "Невірний формат фото", desc: "Завжди перевіряйте фото через офіційний інструмент." },
      { title: "Дублювання заявки", desc: "Більше однієї заявки — дискваліфікація ВСІХ." },
      { title: "Не вказано подружжя або дитину", desc: "Всі члени сім'ї повинні бути включені." },
      { title: "Помилки в іменах", desc: "Імена мають точно збігатися з паспортом." },
      { title: "Невірна країна права", desc: "Вибір країни, на яку немає права." },
      { title: "Втрата номера підтвердження", desc: "Збережіть номер одразу. Без нього результати не перевірити." },
    ],
    afterLabel: "Після відправки",
    afterTitle: "Що відбувається після відправки",
    afterIntro: "Після відправки заявки:",
    afterSteps: [
      { title: "Збережіть номер підтвердження", desc: "Збережіть, сфотографуйте та запишіть. Зберігайте у 2–3 місцях." },
      { title: "Перевіряйте результати онлайн", desc: "З травня на dvprogram.state.gov введіть номер підтвердження." },
      { title: "Немає сповіщень поштою", desc: "Держдеп НЕ надсилає результати поштою. Це шахрайство." },
      { title: "Остерігайтеся шахраїв", desc: "Використовуйте тільки dvprogram.state.gov. Ніколи не платіть за результати." },
    ],
    faqLabel: "Часті запитання",
    faqTitle: "FAQ по заповненню форми DV",
    faqs: [
      { q: "Як заповнити форму лотереї DV?", a: "Перейдіть на dvprogram.state.gov у період реєстрації. Заповніть дані, завантажте фото, додайте сім'ю та відправте." },
      { q: "Яке ім'я вказувати?", a: "Повне ім'я як у паспорті. Спочатку прізвище, потім ім'я." },
      { q: "Чи можна виправити після відправки?", a: "Ні. Можна відправити нову заявку, яка замінить попередню." },
      { q: "Який розмір фото?", a: "600×600 пікселів, JPEG, білий фон, за останні 6 місяців." },
      { q: "Чи потрібно включати подружжя?", a: "Так, навіть якщо він/вона громадянин або резидент США." },
      { q: "Чи потрібно включати дітей?", a: "Так, всіх неодружених до 21 року." },
      { q: "Що якщо втратити номер підтвердження?", a: "Відновити неможливо. Збережіть одразу у кількох місцях." },
      { q: "Коли можна подати заявку?", a: "Зазвичай жовтень–листопад. Дати на dvprogram.state.gov." },
      { q: "Заявка безкоштовна?", a: "Так, повністю. Якщо просять оплату — це шахрайство." },
      { q: "Яку країну права обрати?", a: "Зазвичай країну народження. Якщо не підходить — країну народження подружжя." },
    ],
    finalTitle: "Почніть підготовку до лотереї DV",
    finalSubtitle: "ImmigrationGuide допоможе підготувати заявку з ІІ-помічником та покроковими інструкціями.",
    ctaFinalEligibility: "Перевірити право",
    ctaFinalStart: "Безкоштовний гід",
    ctaFinalChecklist: "Створити чек-лист",
  },
  billing: {
    checking: "Перевіряємо ваш платіж...",
    processingDesc: "Зачекайте, поки ми підтвердимо вашу підписку.",
    successTitle: "Оплата пройшла успішно!",
    successDesc: "Ваша підписка Premium активна. Насолоджуйтесь повним доступом до всіх функцій ШІ.",
    goToDashboard: "Перейти до панелі",
    errorTitle: "Проблема з оплатою",
    errorDesc: "Не вдалося підтвердити ваш платіж. Якщо кошти було списано, підписка активується найближчим часом.",
    cancelTitle: "Оплату скасовано",
    cancelDesc: "Ваш платіж було скасовано. Кошти не списано.",
    backToPricing: "Повернутися до тарифів",
    checkoutError: "Не вдалося розпочати оформлення. Спробуйте ще раз.",
    portalError: "Не вдалося відкрити керування підпискою.",
    redirecting: "Перенаправлення...",
    currentPlan: "Поточний план",
    profileTitle: "Профіль",
    name: "Ім'я",
    email: "Ел. пошта",
    authMethod: "Спосіб входу",
    plan: "Тариф",
    proPlan: "Premium",
    freePlan: "Безкоштовний",
    subscriptionActive: "Підписка Premium активна",
    manageDesc: "Керуйте оплатою, оновіть спосіб оплати або скасуйте підписку.",
    manageSubscription: "Керування підпискою",
    upgradeToPremium: "Перейти на Premium",
    upgradeDesc: "ШІ-аналіз, перевірка документів, відстеження термінів та більше за $15/міс.",
    upgradeNow: "Оновити зараз",
    logoutSuccess: "Ви успішно вийшли з системи",
    logout: "Вийти",
  },
  auth: {
    signInTitle: "З поверненням",
    registerTitle: "Почати",
    signInDesc: "Увійдіть у свій акаунт",
    registerDesc: "Створіть акаунт для навігації імміграцією в США",
    name: "Повне ім'я",
    namePh: "Введіть ваше повне ім'я",
    email: "Електронна пошта",
    emailPh: "Введіть вашу пошту",
    password: "Пароль",
    passwordPh: "Введіть ваш пароль",
    signInBtn: "Увійти",
    registerBtn: "Створити акаунт",
    googleBtn: "Увійти через Google",
    switchToRegister: "Немає акаунту?",
    switchToSignIn: "Вже є акаунт?",
    register: "Реєстрація",
    signIn: "Увійти",
    signingIn: "Вхід...",
    orContinueWith: "або продовжити з",
  },
  dashboard: {
    welcome: "З поверненням, ",
    subtitle: "Над чим ви хочете попрацювати сьогодні?",
    continueTitle: "Продовжити з того місця, де зупинились",
    quickActionsTitle: "Швидкі дії",
    availableForms: "Доступні форми",
    viewAll: "Показати все",
    step: "Крок",
    of: "з",
    actions: [
      { label: "Переглянути форми", desc: "Перегляд та роз'яснення державних форм" },
      { label: "Маршрути", desc: "Перегляд термінів та етапів процесу" },
      { label: "Документи", desc: "Завантаження та управління документами" },
      { label: "Мій хронологія", desc: "Відстеження прогресу вашого процесу" },
      { label: "Чек-листи", desc: "Відстеження необхідних документів" },
      { label: "Терміни", desc: "Відстеження важливих дат" },
    ],
  },
  dvd: {
    badge: "Дати лотереї DV",
    heroTitle: "Дати та графік реєстрації лотереї DV",
    heroSubtitle: "Дізнайтеся, коли відкривається лотерея Green Card, коли оголошуються результати та що відбувається далі в процесі DV.",
    ctaEligibility: "Перевірити право на участь у DV",
    ctaStartGuide: "Почати безкоштовний посібник",
    regLabel: "Реєстрація",
    regTitle: "Період реєстрації лотереї DV",
    regPeriodTitle: "Вікно реєстрації: жовтень – листопад",
    regPeriodDesc: "Період реєстрації лотереї DV зазвичай проходить щороку протягом жовтня та листопада. Вікно онлайн-заявки відкрите приблизно 30 днів. У цей час відповідні кандидати можуть подати заявки через офіційний сайт dvprogram.state.gov.",
    regOfficialTitle: "Офіційні дати оголошуються щорічно",
    regOfficialDesc: "Точні дати реєстрації оголошуються Державним департаментом США на офіційному сайті (dvprogram.state.gov). Дати дещо змінюються щороку, тому завжди перевіряйте офіційне джерело.",
    tlLabel: "Хронологія",
    tlTitle: "Хронологія лотереї DV",
    timelineItems: [
      { period: "Жовтень – Листопад", title: "Період реєстрації", desc: "Вікно онлайн-реєстрації відкривається на dvprogram.state.gov. Кандидати подають особисту інформацію, фото та сімейні дані." },
      { period: "Травень", title: "Оголошення результатів", desc: "Починаючи з травня кандидати можуть перевірити статус відбору онлайн за номером підтвердження." },
      { period: "Жовтень – Вересень", title: "Обробка візи", desc: "Відібрані кандидати проходять візову обробку протягом фіскального року, включаючи DS-260, підготовку документів та співбесіду в посольстві." },
    ],
    ctaTimeline: "Перевірити хронологію Green Card",
    resLabel: "Результати",
    resTitle: "Коли оголошуються результати лотереї DV",
    resCheckTitle: "Перевірте результати за номером підтвердження",
    resCheckDesc: "Починаючи з травня кожного року кандидати можуть перевірити, чи були вони відібрані, відвідавши dvprogram.state.gov та ввівши номер підтвердження. Це єдиний спосіб дізнатися, чи вас обрали.",
    resNoEmailTitle: "Повідомлення електронною поштою не надсилаються",
    resNoEmailDesc: "Уряд США не надсилає електронних листів, пошти чи дзвінків для повідомлення переможців лотереї. Будь-яке повідомлення про виграш у лотереї DV — це шахрайство.",
    ctaCheckResults: "Як перевірити результати DV",
    afterLabel: "Після виграшу",
    afterTitle: "Що відбувається після виграшу в лотереї",
    afterIntro: "Якщо вас відібрано в лотереї DV, вам необхідно виконати кілька кроків для отримання імміграційної візи:",
    afterSteps: [
      { title: "Подати форму DS-260", desc: "Заповніть та надішліть онлайн-заявку на імміграційну візу (форма DS-260) через Консульський електронний центр заявок." },
      { title: "Підготовка документів", desc: "Зберіть усі необхідні документи, включаючи паспорт, свідоцтво про народження, довідку про несудимість та освітні документи." },
      { title: "Співбесіда в посольстві", desc: "Пройдіть особисту співбесіду в посольстві або консульстві США у вашій країні." },
      { title: "Видача візи", desc: "При схваленні імміграційна віза буде вклеєна у ваш паспорт. Ви повинні в'їхати до США до закінчення терміну дії візи." },
    ],
    ctaAfterWinning: "Що робити після виграшу",
    guidesLabel: "Посібники з лотереї DV",
    guidesTitle: "Посібники з лотереї DV",
    guides: [
      { title: "Посібник з лотереї Green Card", desc: "Повний огляд програми DV, право на участь та як подати заявку." },
      { title: "Як заповнити форму DV", desc: "Покрокові інструкції з правильного заповнення заявки." },
      { title: "Вимоги до фото DV", desc: "Точні вимоги до фото та поширені помилки." },
      { title: "Поширені помилки лотереї DV", desc: "Найчастіші помилки, що призводять до дискваліфікації." },
      { title: "Як перевірити результати DV", desc: "Де і коли перевірити статус відбору." },
      { title: "Що робити після виграшу", desc: "Покроковий посібник з візової обробки після відбору." },
      { title: "Право на участь у лотереї DV", desc: "Перевірте, які країни мають право, та які вимоги застосовуються." },
    ],
    faqLabel: "Часті запитання",
    faqTitle: "Часті запитання про дати DV",
    faqs: [
      { q: "Коли відкривається реєстрація лотереї DV?", a: "Реєстрація зазвичай відкривається на початку жовтня щороку. Точні дати оголошуються на dvprogram.state.gov." },
      { q: "Коли виходять результати лотереї DV?", a: "Результати зазвичай доступні починаючи з травня. Перевірте на dvprogram.state.gov за номером підтвердження." },
      { q: "Скільки триває процес DV?", a: "Від реєстрації до отримання візи весь процес зазвичай займає від 1 до 2 років." },
      { q: "Чи можна подавати на лотерею DV щороку?", a: "Так, ви можете подавати щороку, якщо відповідаєте вимогам." },
      { q: "Чи потрібен паспорт для лотереї DV?", a: "Паспорт не потрібен для реєстрації, але він знадобиться пізніше для заявки DS-260 та співбесіди." },
      { q: "Скільки людей виграють у лотереї?", a: "Щороку доступно близько 55 000 віз різноманітності. Відбирається понад 100 000 осіб для компенсації тих, хто не завершує процес." },
      { q: "Чи безкоштовна лотерея DV?", a: "Так, участь повністю безкоштовна. Якщо хтось просить оплату за реєстрацію — це шахрайство." },
      { q: "Чи можуть подружжя подавати окремо?", a: "Так, кожен з подружжя може подати свою заявку. Якщо одного обрано, інший може бути включений як похідний заявник." },
    ],
    finalTitle: "Продовжуйте свій імміграційний шлях з ImmigrationGuide",
    finalSubtitle: "Готуєтесь до лотереї DV чи досліджуєте інші шляхи імміграції — ImmigrationGuide допомагає вам на кожному кроці.",
  },
  dvp: {
    badge: "Вимоги до фото",
    heroTitle: "Посібник з вимог до фото для лотереї DV",
    heroSubtitle: "Дізнайтеся правильний розмір, формат та правила фотографії для заявки на лотерею Green Card.",
    ctaEligibility: "Перевірити право на участь у DV",
    ctaFormGuide: "Як заповнити форму DV",
    ctaChecklist: "Створити список документів",
    ctaStartPrep: "Почати підготовку до DV",
    rulesLabel: "Правила фото",
    rulesTitle: "Офіційні правила фото для лотереї DV",
    rulesIntro: "Державний департамент США має суворі вимоги до фотографій для лотереї DV. Фотографії, що не відповідають правилам, призведуть до автоматичної дискваліфікації.",
    rules: [
      { title: "Квадратне фото", desc: "Ваша фотографія повинна бути ідеальним квадратом: рівно 600 x 600 пікселів. Неквадратні зображення будуть автоматично відхилені." },
      { title: "Однотонний фон", desc: "Фон має бути білим або майже білим. Не допускаються візерунки, меблі, тіні або інші люди позаду вас." },
      { title: "Свіже фото", desc: "Фотографія має бути зроблена протягом останніх 6 місяців. Якщо ваша зовнішність значно змінилася, потрібне нове фото." },
      { title: "Без фільтрів та обробки", desc: "Цифрові фільтри, ретуш, режим краси або будь-яка форма обробки зображення не допускаються." },
    ],
    specsLabel: "Специфікації",
    specsTitle: "Розмір та формат фото",
    specsIntro: "Ваша фотографія для лотереї DV повинна відповідати наступним технічним специфікаціям:",
    specs: [
      { title: "Роздільна здатність: 600 x 600 пікселів", desc: "Зображення повинно бути рівно 600 пікселів завширшки і 600 пікселів заввишки. Фото з низькою роздільною здатністю будуть розмитими і відхилені." },
      { title: "Формат: JPEG (.jpg)", desc: "Фотографія має бути у форматі JPEG. Інші формати, такі як PNG, BMP, TIFF або HEIC, не приймаються." },
      { title: "Розмір файлу: максимум 240 КБ", desc: "Файл фотографії не повинен перевищувати 240 кілобайт. Якщо файл занадто великий, трохи зменшіть якість." },
    ],
    mistakesLabel: "Поширені помилки",
    mistakesTitle: "Поширені помилки з фото",
    mistakesIntro: "Це найчастіші помилки з фотографіями, що призводять до дискваліфікації на лотереї DV:",
    mistakes: [
      { title: "Неправильний фон", desc: "Використання кольорового, візерункового або завантаженого фону замість однотонного білого." },
      { title: "Тіні на обличчі або фоні", desc: "Видимі тіні на обличчі, за головою або на фоновій стіні. Використовуйте рівномірне фронтальне освітлення." },
      { title: "Обрізана або занадто маленька голова", desc: "Голова повинна займати 50-69% висоти зображення. Обрізана або занадто маленька голова призведе до відмови." },
      { title: "Оброблені або відфільтровані зображення", desc: "Будь-яка цифрова обробка — фільтри краси, згладжування шкіри, корекція червоних очей — призведе до дискваліфікації." },
    ],
    guidelinesLabel: "Позиціювання",
    guidelinesTitle: "Приклади правил для фото",
    guidelinesIntro: "Дотримуйтесь цих правил позиціювання та кадрування:",
    guidelines: [
      { title: "Положення голови", desc: "Голова має бути по центру кадру і дивитися прямо вперед. Не нахиляйте і не повертайте голову. Обидва вуха мають бути видні." },
      { title: "Рівень очей", desc: "Очі повинні знаходитися на рівні 56-69% висоти зображення, виміряної знизу." },
      { title: "Висота голови", desc: "Голова (від підборіддя до маківки) повинна займати 50-69% загальної висоти зображення." },
      { title: "Вираз обличчя", desc: "Зберігайте природний, нейтральний вираз із закритим ротом. Легка природна усмішка допустима." },
      { title: "Без аксесуарів", desc: "Зніміть окуляри (навіть прозорі), капелюхи, навушники та будь-які предмети, що закривають обличчя. Релігійні головні убори — єдиний виняток." },
    ],
    faqLabel: "Часті запитання",
    faqTitle: "Часті запитання про фото DV",
    faqs: [
      { q: "Який розмір фото потрібен для лотереї DV?", a: "Фото має бути рівно 600 x 600 пікселів у форматі JPEG, максимальний розмір файлу 240 КБ. Має бути свіжим, зробленим за останні 6 місяців." },
      { q: "Чи можна носити окуляри на фото для лотереї DV?", a: "Ні. З 2016 року Держдепартамент не дозволяє окуляри на фото для лотереї DV, навіть прозорі з діоптріями." },
      { q: "Який колір фону використовувати?", a: "Фон має бути білим або майже білим. Жодні інші кольори, візерунки або об'єкти не повинні бути видні." },
      { q: "Чи можна редагувати або ретушувати фото?", a: "Ні. Будь-яке цифрове редагування, ретуш, фільтр краси або колірна корекція дискваліфікує вашу фотографію." },
      { q: "Чи можна зробити фото на телефон?", a: "Так, можна використовувати камеру смартфона, якщо фото відповідає всім вимогам: 600x600 пікселів, формат JPEG, білий фон." },
      { q: "Як перевірити, чи відповідає моє фото вимогам?", a: "Держдепартамент надає офіційний інструмент перевірки фото на сайті dvprogram.state.gov." },
      { q: "Чи можна носити релігійний головний убір?", a: "Так, релігійні головні убори дозволені, якщо ви носите їх щодня. Однак ваше обличчя повністю має бути видне." },
      { q: "Що станеться, якщо моє фото буде відхилено?", a: "Якщо фото не відповідає вимогам, вся ваша заявка на лотерею DV буде дискваліфікована. Завжди перевіряйте фото перед відправкою." },
    ],
    finalTitle: "Почніть підготовку до лотереї DV",
    finalSubtitle: "ImmigrationGuide допомагає підготувати заявку на лотерею DV за допомогою ШІ, списків документів та покрокових інструкцій.",
  },
  pricing: {
    badge: "Ціни",
    pageTitle: "Прості та прозорі ціни",
    subtitle: "Почніть безкоштовно з доступом до посібників та базових функцій. Оновіть, коли знадобляться аналіз та валідація за допомогою ШІ.",
    freeName: "Безкоштовний",
    freeDesc: "Ідеально для початку",
    proName: "Преміум",
    proDesc: "Повна навігація за допомогою ШІ",
    month: "місяць",
    popular: "Найпопулярніший",
    freeBtn: "Почати безкоштовно",
    proBtn: "Почати Преміум",
    footer: "Усі плани включають доступ до наших посібників по формах та дорожніх карт. Скасування в будь-який час. Без контрактів.",
    freeFeatures: [
      { name: "Доступ до всіх посібників по формах", included: true },
      { name: "Базовий помічник ШІ", included: true },
      { name: "Дорожні карти процесів", included: true },
      { name: "Завантаження та зберігання документів", included: true },
      { name: "Посібники з водійських прав по штатах", included: true },
      { name: "Аналіз та рекомендації ШІ", included: false },
      { name: "Валідація документів за допомогою ШІ", included: false },
      { name: "Персоналізовані чеклісти", included: false },
      { name: "Відстеження хронології", included: false },
      { name: "Відстеження термінів", included: false },
    ],
    proFeatures: [
      { name: "Все з безкоштовного плану" },
      { name: "Аналіз ШІ та персоналізовані рекомендації" },
      { name: "Валідація документів за допомогою ШІ" },
      { name: "Відстеження хронології" },
      { name: "Персоналізовані чеклісти" },
      { name: "Відстеження термінів та нагадування" },
      { name: "Виявлення помилок та попередження" },
      { name: "Пріоритетні відповіді ШІ" },
    ],
  },
  dvNav: {
    label: "Посібники з лотереї DV",
    title: "Посібники з лотереї DV",
    current: "Ви тут",
    toolsLabel: "Інструменти ImmigrationGuide",
    guides: [
      { title: "Посібник з лотереї Green Card" },
      { title: "Дати лотереї DV" },
      { title: "Вимоги до фото" },
      { title: "Як заповнити форму" },
      { title: "Поширені помилки" },
      { title: "Як перевірити результати" },
      { title: "Що робити після виграшу" },
      { title: "Перевірка права на участь" },
    ],
    tools: ["Посібник Green Card", "Калькулятор термінів", "Помічник з імміграції", "Список документів"],
  },
  dvw: {
    badge: "Після виграшу в лотереї DV",
    heroTitle: "Що робити після виграшу в лотереї DV",
    heroSubtitle: "Покроковий посібник для переможців лотереї DV: від підтвердження вибору до отримання імміграційної візи та Green Card.",
    ctaChecklist: "Створити список документів",
    ctaTimeline: "Перевірити хронологію Green Card",
    ctaStartGuide: "Почати посібник з імміграції",
    confirmLabel: "Крок 1",
    confirmTitle: "Підтвердіть свій вибір",
    confirmCheckTitle: "Перевірте результати за номером підтвердження",
    confirmCheckDesc: "Перейдіть на офіційний сайт лотереї DV dvprogram.state.gov та введіть номер підтвердження, отриманий при подачі заявки. Це єдиний законний спосіб перевірити, чи вас обрали.",
    confirmScamTitle: "Остерігайтеся шахрайства",
    confirmScamDesc: "Уряд США не повідомляє переможців лотереї DV електронною поштою, телефоном або листом. Будь-яке повідомлення про виграш — шахрайство. Використовуйте лише dvprogram.state.gov.",
    ds260Label: "Крок 2",
    ds260Title: "Подати форму DS-260",
    ds260Intro: "Після підтвердження вибору ваш наступний крок — заповнити та надіслати онлайн-заявку на імміграційну візу.",
    ds260WhatTitle: "Що таке форма DS-260?",
    ds260WhatDesc: "Форма DS-260 — це онлайн-заявка на імміграційну візу, яку повинні заповнити всі відібрані в лотереї DV. Вона збирає докладну особисту інформацію, історію поїздок, досвід роботи, освіту, сімейні дані та питання безпеки.",
    ds260InfoTitle: "Необхідна інформація",
    ds260InfoDesc: "Для заповнення DS-260 вам знадобляться: дані паспорта, історія поїздок за останні 5 років, трудова історія за останні 10 років, історія освіти, адреси за останні 5 років, сімейна інформація та ваш контакт у США.",
    docsLabel: "Крок 3",
    docsTitle: "Підготуйте документи",
    docsIntro: "Вам необхідно зібрати кілька оригінальних документів для співбесіди в посольстві. Всі документи не англійською повинні включати завірені переклади.",
    docs: [
      { title: "Свідоцтво про народження", desc: "Оригінал свідоцтва про народження із завіреним перекладом англійською, якщо він не англійською." },
      { title: "Дійсний паспорт", desc: "Паспорт, дійсний не менше 6 місяців після планованої дати в'їзду в США." },
      { title: "Довідка про несудимість", desc: "Довідки з поліції кожної країни, де ви проживали 12 місяців або більше з 16 років." },
      { title: "Підтвердження освіти", desc: "Диплом про середню освіту або еквівалент, а також сертифікати про вищу освіту." },
      { title: "Медичний огляд", desc: "Пройдіть медогляд у лікаря, затвердженого посольством США." },
      { title: "Фотографії", desc: "Дві нещодавні фотографії паспортного розміру для кожного заявника. Білий фон, без окулярів." },
      { title: "Підтвердження фінансової підтримки", desc: "Форма I-134 від фінансового спонсора в США або доказ достатніх особистих коштів." },
      { title: "Документи про шлюб та сім'ю", desc: "Свідоцтво про шлюб, свідоцтва про розлучення або смерть та свідоцтва про народження всіх дітей." },
    ],
    interviewLabel: "Крок 4",
    interviewTitle: "Підготовка до співбесіди",
    interviewIntro: "Співбесіда в посольстві — останній основний крок у процесі візи лотереї DV.",
    interviewSchedTitle: "Призначення співбесіди",
    interviewSchedDesc: "Після надсилання DS-260 та всіх документів Консульський центр Кентуккі призначить вашу співбесіду. Ви отримаєте повідомлення з датою, часом та місцем. Співбесіди призначаються за номером справи. Все повинно бути завершено до 30 вересня.",
    interviewPrepTitle: "Що очікувати в посольстві",
    interviewPrepDesc: "Приходьте рано з усіма оригіналами документів. Співбесіда триває 10-20 хвилин. Консульський офіцер перевірить вашу особу, документи та задасть питання про вашу біографію. Будьте чесні та прямі.",
    bulletinLabel: "Крок 5",
    bulletinTitle: "Візовий бюлетень та номери справ",
    bulletinIntro: "Розуміння вашого номера справи та Візового бюлетеня критично важливе для відстеження прогресу в процесі лотереї DV.",
    bulletinCaseTitle: "Як працюють номери справ",
    bulletinCaseDesc: "При виборі ви отримуєте номер справи, що визначає, коли буде призначена співбесіда. Держдепартамент публікує щомісячний Візовий бюлетень, що показує, які номери обробляються. Всі візи DV повинні бути видані до 30 вересня.",
    faqLabel: "Часті запитання",
    faqTitle: "Часті запитання після виграшу",
    faqs: [
      { q: "Який крайній термін після виграшу в лотереї DV?", a: "Всі візи повинні бути видані до 30 вересня фіскального року. Продовжень немає." },
      { q: "Скільки триває процес візи DV?", a: "Від вибору до видачі візи процес займає від 6 до 12 місяців залежно від номера справи." },
      { q: "Що відбувається на співбесіді в посольстві?", a: "Консульський офіцер перевіряє документи, ідентичність та задає питання про вашу біографію. Триває 10-20 хвилин." },
      { q: "Чи можу я взяти сім'ю?", a: "Так. Ваш подружжя та неодружені діти до 21 року можуть отримати похідні візи DV." },
      { q: "Що якщо я не можу прийти на співбесіду?", a: "Зв'яжіться з посольством якнайшвидше для перепризначення. Всі візи повинні бути видані до 30 вересня." },
      { q: "Чи потрібен фінансовий спонсор?", a: "Ви повинні довести, що не станете «тягарем для суспільства» через I-134, особисті заощадження або пропозицію роботи." },
      { q: "Що таке Візовий бюлетень?", a: "Щомісячна публікація, що показує, які номери справ DV обробляються наразі." },
      { q: "Що відбувається після схвалення співбесіди?", a: "Паспорт повертається із запечатаною імміграційною візою через 1-2 тижні. Ви повинні в'їхати в США до закінчення терміну." },
    ],
    finalTitle: "Навігація по DV з ImmigrationGuide",
    finalSubtitle: "Від підготовки DS-260 до співбесіди — ImmigrationGuide веде вас на кожному кроці.",
  },
  dvm: {
    badge: "Поширені помилки",
    heroTitle: "Поширені помилки лотереї DV",
    heroSubtitle: "Уникайте найпоширеніших помилок, що призводять до дискваліфікації в лотереї DV.",
    ctaEligibility: "Перевірити право на участь",
    ctaFormGuide: "Як заповнити форму DV",
    ctaChecklist: "Перевірити мій список",
    ctaStartGuide: "Почати безкоштовний посібник",
    mistakeLabel: "Помилка",
    tipLabel: "Як уникнути:",
    sections: [
      { title: "Дублювання заявок", subtitle: "Подання кількох заявок", desc: "Подання кількох заявок — одна з найпоширеніших і найсерйозніших помилок. Держдепартамент використовує ПЗ для виявлення дублікатів. Усі заявки такої особи дискваліфікуються назавжди.", tip: "Подавайте лише одну заявку на рік. При помилці можна подати нову в період реєстрації." },
      { title: "Помилки з фото", subtitle: "Неправильний формат, фон або обробка", desc: "Помилки з фото — причина номер один дискваліфікації. Потрібно: рівно 600x600 пікселів, формат JPEG, білий фон, зроблене за останні 6 місяців, без окулярів, без обробки.", tip: "Завжди використовуйте офіційний інструмент перевірки фото на dvprogram.state.gov." },
      { title: "Пропущені члени сім'ї", subtitle: "Не вказано подружжя або дітей", desc: "Усі заявники повинні вказати подружжя та всіх неодружених дітей до 21 року.", tip: "Вкажіть усіх необхідних членів сім'ї, незалежно від їх поточного імміграційного статусу." },
      { title: "Неправильні особисті дані", subtitle: "Помилки в імені або країні народження", desc: "Будь-яка розбіжність між даними заявки та офіційними документами може призвести до відмови у візі.", tip: "Копіюйте інформацію безпосередньо з паспорта. Перевіряйте кожне поле перед відправкою." },
      { title: "Втрата номера підтвердження", subtitle: "Без нього неможливо перевірити результати", desc: "Після подання заявки ви отримуєте унікальний номер підтвердження. Це єдиний спосіб перевірити, чи вас обрали. При втраті відновити неможливо.", tip: "Одразу після подання: зробіть скріншот, запишіть на папері, збережіть в email та в додатку нотаток. Збережіть мінімум у 3 місцях." },
    ],
    faqLabel: "Часті запитання",
    faqTitle: "Часті запитання про помилки DV",
    faqs: [
      { q: "Яка найчастіша помилка лотереї DV?", a: "Помилки з фото — найчастіша причина дискваліфікації." },
      { q: "Чи можу я бути дискваліфікований за дублювання?", a: "Так. Якщо система виявить більше однієї заявки, всі будуть дискваліфіковані." },
      { q: "Що буде, якщо я забуду вказати подружжя?", a: "Вам можуть відмовити у візі на співбесіді." },
      { q: "Чи можу я виправити заявку після відправки?", a: "Не можна редагувати, але можна подати нову в період реєстрації." },
      { q: "Що якщо моє ім'я написано по-різному в документах?", a: "Використовуйте написання з паспорта у формі DV." },
      { q: "Чи можна відновити втрачений номер підтвердження?", a: "Ні. Відновити втрачений номер неможливо." },
      { q: "Чи дискваліфікує фото в окулярах?", a: "Так. З 2016 року окуляри не допускаються на фото лотереї DV." },
      { q: "Чи може хтось подати заявку за мене?", a: "Хтось може допомогти, але ви відповідаєте за те, щоб була подана лише одна заявка." },
    ],
    finalTitle: "Подавайте з впевненістю з ImmigrationGuide",
    finalSubtitle: "Уникайте поширених помилок та правильно підготуйте заявку за допомогою ШІ.",
  },
  pages: {
    formsTitle: "Бібліотека форм",
    formsSubtitle: "Перегляд державних форм за категоріями з поясненнями ШІ.",
    catImmigration: "Імміграція",
    catSocialSecurity: "Державні послуги",
    catDmv: "Автоінспекція",
    diffEasy: "Легкий",
    diffMedium: "Середній",
    diffHard: "Складний",
    startWizard: "Запустити помічник",
    backToForms: "Усі форми",
    quickTip: "Порада:",
    commonMistakes: "Типові помилки",
    explainWithAI: "Пояснити з ШІ",
    aiExplanation: "Пояснення ШІ",
    fieldRequired: "Обов'язкове",
    fieldQuestion: "Задайте питання щодо цього поля (необов'язково)...",
    fields: "Полів:",
    estTimeline: "Орієнтовні терміни:",
    roadmapsTitle: "Маршрути процесів",
    roadmapsSubtitle: "Наочні керівництва по імміграційних та державних процесах.",
    backToRoadmaps: "Усі маршрути",
    tips: "Поради:",
    checklistsTitle: "Чек-листи документів",
    checklistsSubtitle: "ШІ-генеровані списки необхідних документів для ваших форм.",
    generate: "Створити",
    generateChecklist: "Створити чек-лист документів",
    selectForm: "Оберіть форму",
    chooseForm: "Оберіть форму...",
    yourSituation: "Ваша ситуація (необов'язково)",
    situationPlaceholder: "Опишіть вашу ситуацію для персоналізованого чек-листа...",
    generateWithAI: "Створити за допомогою ШІ",
    noChecklists: "Чек-листів ще немає",
    noChecklistsDesc: "Створіть свій перший чек-лист документів за допомогою ШІ.",
    completed: "завершено",
    ofTotal: "з",
    deadlinesTitle: "Трекер термінів",
    deadlinesSubtitle: "Відстежуйте важливі терміни подачі документів.",
    addDeadline: "Додати термін",
    newDeadline: "Новий термін",
    deadlineTitle: "Назва",
    deadlineDesc: "Опис (необов'язково)",
    dueDate: "Дата здачі",
    reminderDays: "Нагадування (за днів до)",
    save: "Зберегти",
    noDeadlines: "Термінів ще немає",
    noDeadlinesDesc: "Додайте перший термін, щоб нічого не пропустити.",
    overdue: "Прострочено",
    dueToday: "Сьогодні",
    daysLeft: "днів залишилось",
    documentsTitle: "Менеджер документів",
    documentsSubtitle: "Завантажуйте, організуйте та перевіряйте імміграційні документи.",
    uploadDocument: "Завантажити",
    uploadDialogTitle: "Завантаження документа",
    docFormLabel: "Пов'язана форма",
    docTypePlaceholder: "Оберіть тип документа...",
    docTypes: "Паспорт,Свідоцтво про народження,Свідоцтво про шлюб,Диплом,Лист від роботодавця,Фінансовий документ,Фото,Інше",
    dragDrop: "Перетягніть файл або натисніть для вибору",
    maxFileSize: "PDF, JPG, PNG до 10МБ",
    uploading: "Завантаження...",
    upload: "Завантажити",
    noDocs: "Документів ще немає",
    noDocsDesc: "Завантажте перший документ для початку роботи.",
    validateDocs: "Перевірити документи",
    validating: "Перевірка...",
    validateForForm: "Оберіть форму для перевірки документів на відповідність вимогам.",
    selectFormFirst: "Спочатку оберіть форму",
    aiValidation: "ШІ-перевірка документів",
    proFeature: "Функція Pro",
    timelineTitle: "Мій прогрес",
    timelineSubtitle: "Відстежуйте ваш прогрес в імміграційних процесах.",
    selectProcess: "Оберіть процес для відстеження",
    trackProcess: "Відстежувати процес",
    saveProgress: "Зберегти прогрес",
    saving: "Збереження...",
    currentStep: "Поточний етап",
    notes: "Нотатки",
    notesPlaceholder: "Додайте нотатки про ваш прогрес...",
    progressSaved: "Прогрес збережено!",
    noTimelines: "Процесів ще немає",
    noTimelinesDesc: "Оберіть процес для відстеження прогресу.",
    wizardComplete: "Форму заповнено!",
    wizardCompleteDesc: "Ви заповнили всі поля для",
    checkForErrors: "Перевірити помилки",
    aiAnalysis: "ШІ-аналіз (Pro)",
    generateDocChecklist: "Створити чек-лист",
    aiAnalysisInsights: "ШІ-аналіз та рекомендації",
    confidence: "Впевненість:",
    estProcessingTime: "Орієнт. термін обробки",
    riskLevel: "Рівень ризику",
    potentialIssues: "Можливі проблеми:",
    recommendations: "Рекомендації:",
    nextSteps: "Наступні кроки:",
    noErrorsDetected: "Помилок не знайдено! Ваші відповіді виглядають добре.",
    foundIssues: "можливих проблем(и)",
    backToDashboard: "Назад до панелі",
    exitWizard: "Вихід",
    stepOf: "Крок {current} з {total}",
    yourAnswer: "Ваша відповідь",
    selectOption: "Оберіть варіант...",
    typeAnswer: "Введіть вашу відповідь...",
    watchOut: "Зверніть увагу",
    skip: "Пропустити",
    finish: "Завершити",
    next: "Далі",
    thisFieldRequired: "Це поле обов'язкове",
    startGuided: "Запустити помічник",
  },

  trust: {
    title: "Ваші дані в безпеці",
    encryptedTitle: "Наскрізне шифрування",
    encryptedDesc: "Усі дані шифруються при передачі (TLS) та зберіганні (AES-256). Ваша інформація ніколи не зберігається у відкритому вигляді.",
    independentTitle: "Незалежний та конфіденційний",
    independentDesc: "Ми не пов'язані з USCIS або будь-яким державним органом і ніколи не передаємо ваші дані державним органам.",
    deleteTitle: "Видалення у будь-який час",
    deleteDesc: "Запросіть повне видалення даних у будь-який час.",
    deleteLink: "Переглянути нашу політику конфіденційності та видалення",
  },
  legal: {
    banner: "ImmigrationGuide не є юридичною фірмою і не надає юридичних консультацій. Не пов'язаний з USCIS або державними органами.",
  },
};
